import { Howl } from 'howler';

import * as Promise from 'bluebird';

Promise.config({ cancellation: true });

const ERR_HOWL = (src, msg) => ({
  /* eslint-disable no-console */
  play: () => {
    console.warn(`There was an error loading the sound ${src}, unable to play it.`);
    console.warn(`Cause of error: ${msg}`);
  }
});

const defaultOptions = {
  // preload: true
};

export const newSound = (src, options = {}) =>
  new Promise((resolve, reject, onCancel) => {
    const audio = new Howl({
      src,
      ...defaultOptions,
      ...options,
      onload: () => resolve(audio),
      onloaderror: (e, msg) => {
        resolve(ERR_HOWL(src, msg));
      }
    });
    onCancel(() => audio && audio.unload());
  });
